import { useEffect, useState } from "react";
import { HiChevronLeft, HiChevronRight } from "react-icons/hi";
import { CarouselControlsNumbers } from "./CarouselControlsNumbers";

export const CarouselControls = ({
  currentItem,
  totalItems,
  onSelected,
}: {
  currentItem: number;
  totalItems: number;
  onSelected: (item: number) => void;
}) => {
  const [startingItem, setStartingItem] = useState(currentItem);

  // emulate the somewhat funky startingItem behavior from the AEM control
  // if a user clicks on one of the page numbers already in view, we don't
  // adjust the starting item.
  useEffect(() => {
    if (currentItem < startingItem) {
      setStartingItem(currentItem);
    } else if (currentItem > startingItem + 2) {
      setStartingItem(currentItem - 2);
    }
  }, [currentItem]);

  return (
    <div className="tw:flex tw:justify-center tw:mt-[60px] tw:gap-2">
      <div
        className="tw:m-2"
        onClick={() => currentItem > 0 && onSelected(currentItem - 1)}
      >
        <HiChevronLeft
          className="tw:w-8 tw:h-8"
          color={currentItem === 0 ? "white" : undefined} // hide when not available
        />
      </div>

      <CarouselControlsNumbers
        startingItem={startingItem}
        currentItems={currentItem}
        totalItems={totalItems}
        onClick={(slide) => onSelected(slide)}
      />

      <div
        className="tw:m-2"
        onClick={() =>
          currentItem < totalItems - 1 && onSelected(currentItem + 1)
        }
      >
        <HiChevronRight
          className="tw:w-8 tw:h-8"
          color={currentItem >= totalItems - 1 ? "white" : undefined} // hide when not available
        />
      </div>
    </div>
  );
};
